









































import { Component, Vue, Prop } from "vue-property-decorator";
import { themed } from "@/utils/Theme";
import {
  COLOR_APP_UPDATE_BANNER_BACKGROUND,
  COLOR_APP_UPDATE_BANNER_BACKGROUND_DARK,
  COLOR_APP_UPDATE_BANNER_BORDER,
  COLOR_APP_UPDATE_BANNER_BORDER_DARK,
} from "@/utils/colors";

/**
 * "A new version is available" banner.
 *
 * Deliberately dumb: props in, events out. Whether it should be on screen, and what pressing a
 * button does, is decided by the authenticated shell (`Scaffold.vue`) from `AppUpdateModule`.
 *
 * It is an inline banner rather than a snackbar for two reasons: the repo's global snackbar carries
 * a single message with no actions and auto-dismisses after 5s (see `SnackbarModule`), and this
 * message must never time out. It is non-blocking either way — the user can ignore it for as long
 * as they like, and LATER hides it for the rest of the session.
 */
@Component
export default class AppUpdateBanner extends Vue {
  @Prop({ default: false })
  visible!: boolean;

  /** True while the reload is being applied, so REFRESH can show a busy state. */
  @Prop({ default: false })
  applying!: boolean;

  get backgroundColor() {
    return themed(
      COLOR_APP_UPDATE_BANNER_BACKGROUND,
      COLOR_APP_UPDATE_BANNER_BACKGROUND_DARK
    );
  }

  get borderStyle() {
    const borderColor = themed(
      COLOR_APP_UPDATE_BANNER_BORDER,
      COLOR_APP_UPDATE_BANNER_BORDER_DARK
    );

    return `border-color: ${borderColor}`;
  }
}
